module.exports = __webpack_public_path__ + "files/cfcf02bdcb96ed78c2fa10393e000310.png";